/**
 * JSON 版本
 */
export var JSONSceneVersion;
(function (JSONSceneVersion) {
    JSONSceneVersion["1_0"] = "1.0";
    JSONSceneVersion["1_1"] = "1.1";
    JSONSceneVersion["1_2"] = "1.2";
    JSONSceneVersion["1_3"] = "1.3";
    JSONSceneVersion["1_5"] = "1.5";
    JSONSceneVersion["1_8"] = "1.8";
    JSONSceneVersion["2_0"] = "2.0";
    JSONSceneVersion["2_1"] = "2.1";
    JSONSceneVersion["2_2"] = "2.2";
    JSONSceneVersion["2_3"] = "2.3";
    JSONSceneVersion["2_4"] = "2.4";
    JSONSceneVersion["3_0"] = "3.0";
    JSONSceneVersion["3_1"] = "3.1";
    JSONSceneVersion["3_2"] = "3.2";
    JSONSceneVersion["3_3"] = "3.3";
    JSONSceneVersion["3_4"] = "3.4";
    JSONSceneVersion["3_5"] = "3.5";
    JSONSceneVersion["3_6"] = "3.6";
    JSONSceneVersion["LATEST"] = "3.6";
})(JSONSceneVersion || (JSONSceneVersion = {}));
